import { CopyToClipboardAction } from '@/helpers/CopyClipboard';
import { slugTextConverter } from '@/helpers/dataHelper';
import { isLogin } from '@/helpers/loginHelper';
import useWidth from '@/helpers/widthUtil';
import { Button, Modal, Popconfirm, Skeleton, Space } from 'antd';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  clearRoomDataToInitial,
  clearRoomError,
  clearRoomQuery,
  getRoomDiscussion,
  joinRoomRequest,
  leaveRoomRequest,
  respondRoomInviteRequest,
  setRoomQueryData,
} from '../../../actions/room';
import AboutRoom from './details/about';
import AboutCard from './details/about/AboutCard';
import Assessment from './details/assessment';
import Discussion from './details/discussion';
import PrivateRoomLocked from './details/discussion/private room/private-room.locked';
import RoomMembers from './details/members';
import NoticeRoom from './details/notice';
import RoomSchedule from './details/schedule';
import RoomSettings from './details/settings';
import { addData, setData } from '@/actions/auth';
import Onboarding from '../onboarding';

const Index = ({ roomData, roomSlug = null }) => {
  const currentUrl = typeof window !== 'undefined' && window.location.href;
  const dispatch = useDispatch();
  const router = useRouter();
  const { isMobile, isTablet } = useWidth();
  const { discussionQuery, user, roomDetail, rolePermissionKey } = useSelector(
    (state: RootStateOrAny) => ({
      discussionQuery: state.roomReducer.query.discussions,
      user: state.auth?.creds?.user_data,
      roomDetail: state.roomReducer?.roomDetail,
      rolePermissionKey: state.auth?.creds?.user_data?.permission,
    })
  );
  const { loginModal } = useSelector(
    (state: RootStateOrAny) => state.auth.helperObj
  );

  let loading = roomDetail && roomDetail?.loading,
    joinRoomStatus = roomDetail && roomDetail?.joinRoomStatus,
    leaveRoomStatus = roomDetail && roomDetail?.leaveRoomStatus,
    respondToInvitationStatus = roomDetail && roomDetail?.respondToInvitationStatus,
    rejectToInvitationStatus = roomDetail && roomDetail?.rejectToInvitationStatus,
    isSuspendedRoom = roomDetail && roomDetail?.error?.suspend_status;

  const {
    id,
    title = '',
    course,
    room_type,
    is_member,
    slug,
    created_by,
    image,
    permission,
    roommember: { member_status = null, member_id = null } = {},
  } = roomData || {};
  const isStaff = user?.user_type === 'staff';

  const [activeTab, setActiveTab] = React.useState<any>(
    router?.query?.tab ? router?.query?.tab : 'discussion'
  );

  useEffect(() => {
    if (router?.query?.tab === 'announcement' || router?.query?.announcement) {
      setActiveTab('announcement');
    } else if (router?.query?.tab === 'discussion' || router?.query?.discussion) {
      setActiveTab('discussion');
    } else if (router?.query?.tab === 'members' || router?.query?.member) {
      setActiveTab('members');
    } else if (router?.query?.tab === 'assessment' || router?.query?.assessment) {
      setActiveTab('assessment');
    } else if (router?.query?.tab === 'settings' || router?.query?.settings) {
      setActiveTab('settings');
    } else if (router?.query?.tab === 'live' || router?.query?.live) {
      setActiveTab('live');
    } else if (router?.query?.tab === 'about') {
      setActiveTab('about');
    }
  }, [router?.query?.tab]);

  useEffect(() => {
    dispatch(clearRoomQuery());
    // dispatch(clearRoomData());
    dispatch(clearRoomError());
    return () => {
      dispatch(clearRoomDataToInitial());
    };
  }, []);

  useEffect(() => {
    if ((is_member && roomData) || roomData?.room_type === 0) {
      fetchDiscussion();
    }
  }, [activeTab, is_member, roomData]);

  useEffect(() => {
    if (leaveRoomStatus === 'success') {
      window.location.pathname = '/room';
    }
  }, [leaveRoomStatus]);

  const fetchDiscussion = () => {
    if (activeTab === 'discussion' && roomSlug) {
      dispatch(clearRoomError());
      dispatch(
        setRoomQueryData({
          name: 'discussions',
          value: { ...discussionQuery, page: 1, per_page: 5, room: roomSlug },
        })
      );
      if (router?.query?.discussion) {
        dispatch(
          getRoomDiscussion({
            data: {
              ...discussionQuery,
              page: 1,
              per_page: 5,
              room: roomSlug,
              order_by_id: router?.query?.discussion,
            },
          })
        );
      } else {
        dispatch(
          getRoomDiscussion({
            data: { ...discussionQuery, page: 1, per_page: 5, room: roomSlug },
          })
        );
      }
    }
  };

  const joinRoom = () => {
    dispatch(joinRoomRequest({ room: slug || roomSlug }));
  };

  const leaveRoom = () => {
    dispatch(leaveRoomRequest({ room: slug }));
  };

  const respondInvitation = (status) => {
    const data = {
      status,
      room: slug,
      memberId: member_id,
    };
    dispatch(
      respondRoomInviteRequest({
        data,
      })
    );
  };

  const ModalLoginOpen = (): void => {
    dispatch(
      setData({
        name: 'helperObj',
        key: 'loginModal',
        value: !loginModal,
      })
    );
  };

  return (
    <>
      <Modal
        visible={loginModal}
        onCancel={() => {
          ModalLoginOpen();
          dispatch(
            addData({
              key: 'isCurriculumRedirect',
              value: false,
            })
          );
          dispatch(
            addData({
              key: 'courseData',
              value: {},
            })
          );
        }}
        footer={[]}
        maskClosable={false}
        width={450}
      >
        <div className="banner-form">
          <Onboarding is_instructor={false} isLoginPage={false} isModal />
        </div>
      </Modal>
      <div
        className="main-wrapper course-details-page"
        style={{
          backgroundColor: '#F0F2F5',
        }}
      >
        {/* Course Details */}
        <section className="custom-container">
          <div className="room-banner-container">
            {loading ? (
              <Skeleton.Image
                style={{
                  objectFit: 'cover',
                  verticalAlign: 'center',
                  height: '20rem',
                  borderTopLeftRadius: '0.25rem',
                  borderTopRightRadius: '0.25rem',
                  background: 'none',
                }}
              />
            ) : (
              <img
                src={image ? image : '/images/room-banner.webp'}
                alt="Image"
                className="w-100 room-banner"
                style={{
                  objectFit: 'cover',
                  verticalAlign: 'center',
                  height: '20rem',
                  borderTopLeftRadius: '0.25rem',
                  borderTopRightRadius: '0.25rem',
                }}
              />
            )}
          </div>
          <Col
            className="p-0 bg-white rounded-bottom "
            style={{ boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)' }}
          >
            <div>
              <div
                className={`public-profile position-relative p-3  d-flex flex-column`}
                style={{ zIndex: 1 }}
              >
                <div className="d-flex align-items-center">
                  <div className="d-flex w-100 gap-2 align-items-center justify-content-between">
                    {loading ? (
                      <Skeleton.Button />
                    ) : (
                      <h3
                        className="font-weight-bold text-capitalize mb-0"
                        style={{ fontSize: '22px' }}
                      >
                        {title || slugTextConverter(roomSlug)}
                      </h3>
                    )}
                    <div className="d-flex gap-2">
                      {loading ? (
                        <Skeleton.Button />
                      ) : (
                        title && (
                          <Space>
                            <Button
                              type="primary"
                              htmlType="submit"
                              className="ml-2 rounded-lg "
                              onClick={() =>
                                CopyToClipboardAction(currentUrl, 'success')
                              }
                            >
                              <i className="fas fa-share float-left mt-1 mr-1"></i>
                              Share
                            </Button>
                          </Space>
                        )
                      )}

                      {
                        // !is_member && room_type === 0 ? (
                        // user?.user_type !== 'client' &&
                        ((member_status &&
                          Object?.keys(member_status)?.length > 0 &&
                          member_status !== 0) ||
                          room_type === 0 ||
                          isStaff) &&
                        // isLogin() &&
                        !is_member ? (
                          loading ? (
                            <Skeleton.Button />
                          ) : (
                            <Button
                              className="bg-danger text-white rounded-lg border-0"
                              style={{ borderColor: 'none !important' }}
                              disabled={joinRoomStatus === 'request'}
                              onClick={() => {
                                isLogin() ? joinRoom() : ModalLoginOpen();
                              }}
                            >
                              {joinRoomStatus === 'request' && (
                                <Spinner
                                  as="span"
                                  animation="grow"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  className="mr-2"
                                />
                              )}
                              Join Room
                            </Button>
                          )
                        ) : (
                          room_type === 0 &&
                          is_member &&
                          user?.id !== created_by && (
                            <Button
                              className="bg-danger text-white rounded-lg border-0"
                              disabled={leaveRoomStatus === 'request'}
                              style={{ borderColor: 'none !important' }}
                              onClick={() => leaveRoom()}
                            >
                              {leaveRoomStatus === 'request' && (
                                <Spinner
                                  as="span"
                                  animation="grow"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  className="mr-2"
                                />
                              )}
                              Leave Room
                            </Button>
                          )
                        )
                      }

                      {/* Private Room */}
                      {room_type !== 0 &&
                        user?.id !== created_by &&
                        member_status == '1' && (
                          <div className="text-center">
                            <Popconfirm
                              title="Sure to leave room?"
                              onConfirm={leaveRoom}
                            >
                              <Button
                                title="Leave Room"
                                disabled={leaveRoomStatus === 'request'}
                                className="bg-danger text-white rounded-lg border-0"
                                style={{ borderColor: 'none !important' }}
                              >
                                {leaveRoomStatus === 'request' && (
                                  <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="mr-2"
                                  />
                                )}{' '}
                                Leave Room
                              </Button>
                            </Popconfirm>
                          </div>
                        )}

                      {/* For pending users in private rooms */}
                      {room_type === 1 &&
                        member_status !== null &&
                        member_status === 0 && (
                          <div className="d-flex justify-content-end gap-3 mr-3">
                            <Button
                              type="primary"
                              className="ml-2 rounded-lg "
                              loading={respondToInvitationStatus === 'request'}
                              onClick={() => respondInvitation(1)}
                            >
                              Accept
                            </Button>
                            <Button
                              className="bg-danger text-white rounded-lg border-0"
                              loading={rejectToInvitationStatus === 'request'}
                              onClick={() => respondInvitation(2)}
                            >
                              Reject
                            </Button>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {loading
              ? ''
              : title &&
                roomData?.is_member && <div className="border-top mx-3"></div>}
            <section className="room-details-area pt-2">
              <div className="px-3">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="course-details-top">
                      <div className="heading"></div>
                      <div className="course-tab-list">
                        <div className="flex-column">
                          {/* {roomData?.is_member && ( */}
                          <>
                            <Nav className="d-flex flex-row bg-white mx-auto m-0">
                              <NavItem>
                                {!loading && (
                                  <NavLink
                                    className={`${
                                      isMobile ? 'px-1 mr-1 font-size-sm' : ''
                                    } ${classnames({
                                      active: activeTab === 'discussion',
                                    })} `}
                                    onClick={() => {
                                      router.push({
                                        query: {
                                          tab: 'discussion',
                                        },
                                      });
                                    }}
                                  >
                                    Discussion
                                  </NavLink>
                                )}
                              </NavItem>
                              {roomData?.is_member && (
                                <>
                                  {/* <NavItem>
                                    <NavLink
                                      className={`${
                                        isMobile ? 'px-1 mr-1 font-size-sm' : ''
                                      } ${classnames({
                                        active: activeTab === 'discussion',
                                      })} `}
                                      onClick={() => {
                                        router.push({
                                          query: {
                                            tab: 'discussion',
                                          },
                                        });
                                      }}
                                    >
                                      Discussion
                                    </NavLink>
                                  </NavItem> */}
                                  {roomData?.room_type !== 0 && (
                                    <>
                                      <NavItem>
                                        <NavLink
                                          className={`${
                                            isMobile ? 'px-1 mr-1 font-size-sm' : ''
                                          }  ${classnames({
                                            active: activeTab === 'announcement',
                                          })}`}
                                          onClick={() => {
                                            router.push({
                                              query: {
                                                tab: 'announcement',
                                              },
                                            });
                                          }}
                                        >
                                          Announcement
                                        </NavLink>
                                      </NavItem>
                                      <NavItem>
                                        <NavLink
                                          className={`${
                                            isMobile ? 'px-1 mr-1 font-size-sm' : ''
                                          }  ${classnames({
                                            active: activeTab === 'live',
                                          })}`}
                                          onClick={() => {
                                            router.push({
                                              query: {
                                                tab: 'live',
                                              },
                                            });
                                          }}
                                        >
                                          Live
                                        </NavLink>
                                      </NavItem>
                                      {course && (
                                        <NavItem>
                                          <NavLink
                                            className={`${
                                              isMobile
                                                ? 'px-1 mr-1 font-size-sm'
                                                : ''
                                            }  ${classnames({
                                              active: activeTab === 'assessment',
                                            })}`}
                                            onClick={() => {
                                              router.push({
                                                query: {
                                                  tab: 'assessment',
                                                },
                                              });
                                            }}
                                          >
                                            Assessment
                                          </NavLink>
                                        </NavItem>
                                      )}
                                    </>
                                  )}
                                  {/* permission key below controls permission for staff(Permission always
                                true) or teachers(associcated with course- always true) */}

                                  {(permission ||
                                    rolePermissionKey?.roommember
                                      ?.view_roommember) && (
                                    <NavItem>
                                      <NavLink
                                        className={`${
                                          isMobile ? 'px-1 mr-1 font-size-sm' : ''
                                        }  ${classnames({
                                          active: activeTab === 'members',
                                        })}`}
                                        onClick={() => {
                                          router.push({
                                            query: {
                                              tab: 'members',
                                            },
                                          });
                                        }}
                                      >
                                        Members
                                      </NavLink>
                                    </NavItem>
                                  )}
                                  {permission && (
                                    <NavItem>
                                      <NavLink
                                        className={`${
                                          isMobile ? 'px-1 font-size-sm' : ''
                                        }  ${classnames({
                                          active: activeTab === 'settings',
                                        })}`}
                                        onClick={() => {
                                          router.push({
                                            query: {
                                              tab: 'settings',
                                            },
                                          });
                                        }}
                                      >
                                        Settings
                                      </NavLink>
                                    </NavItem>
                                  )}
                                </>
                              )}

                              {(isMobile || isTablet) && !loading && (
                                <NavItem>
                                  <NavLink
                                    className={` ${
                                      isMobile ? 'px-1 mr-1 font-size-sm' : ''
                                    } ${classnames({
                                      active: activeTab === 'about',
                                    })}`}
                                    onClick={() => {
                                      router.push({
                                        query: {
                                          tab: 'about',
                                        },
                                      });
                                    }}
                                  >
                                    About
                                  </NavLink>
                                </NavItem>
                              )}
                            </Nav>
                          </>
                          {/* )}  */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Col>
        </section>
        <section className="room-details-area  py-3">
          <div className="custom-container">
            <div className="row">
              <div
                className={`col-lg-7 ${
                  isTablet ? 'col-md-12' : 'col-md-7'
                } col-sm-12`}
              >
                {/* If user is suspended from room */}
                {isSuspendedRoom && (
                  <>
                    <div className="w-100 d-flex justify-content-center">
                      <img
                        src={'/images/not allowed.webp'}
                        alt="suspended image"
                        // className="w-100"
                        style={{
                          height: '20rem',
                        }}
                        // className="d-flex justify-content-center"
                      />
                    </div>
                    <h4 className="text-center text-secondary mt-2">
                      You are not allowed here!!
                    </h4>
                  </>
                )}
                <div className="course-details-top">
                  <div className="course-tab-list">
                    <div className="flex-column">
                      <TabContent activeTab={activeTab} className="mt-0">
                        {!is_member ? (
                          loading ? (
                            <Skeleton active />
                          ) : // Private room if not joined
                          roomData?.room_type === 1 ? (
                            <TabPane tabId="discussion" className="discussion-tab">
                              <PrivateRoomLocked />
                            </TabPane>
                          ) : (
                            // Pubic room if not joined
                            roomData?.room_type === 0 && (
                              <TabPane tabId="discussion" className="discussion-tab">
                                <Discussion
                                  roomId={id}
                                  roomSlug={slug}
                                  roomData={roomData}
                                />
                              </TabPane>
                            )
                          )
                        ) : (
                          //Private or public room if joined
                          (roomData?.room_type === 1 ||
                            roomData?.room_type === 0) && (
                            <TabPane tabId="discussion" className="discussion-tab">
                              <Discussion
                                roomId={id}
                                roomSlug={slug}
                                roomData={roomData}
                              />
                            </TabPane>
                          )
                        )}

                        {
                          // (is_member || roomData?.room_type === 0)  &&
                          (isMobile || isTablet) && (
                            <TabPane
                              tabId="about"
                              key="about"
                              className="about-tab mb-5"
                            >
                              <AboutRoom {...roomData} />
                            </TabPane>
                          )
                        }
                        {is_member && roomData?.room_type !== 0 && (
                          <>
                            <TabPane
                              tabId="announcement"
                              key="announcement"
                              className="announcement-tab"
                            >
                              <NoticeRoom
                                dashboard={isStaff}
                                roomId={roomData?.id}
                                roomSlug={roomSlug}
                                has_permission={permission}
                              />
                            </TabPane>
                            <TabPane
                              tabId="live"
                              key="live"
                              className="live-tab mb-5"
                            >
                              {
                                <RoomSchedule
                                  roomSlug={roomSlug}
                                  roomId={roomData?.id}
                                  permission={permission}
                                />
                              }
                            </TabPane>
                            <TabPane
                              tabId="assessment"
                              key="assessment"
                              className="assessment-tab mb-5"
                            >
                              {
                                <Assessment
                                  roomSlug={roomSlug}
                                  roomId={roomData?.id}
                                  courseSlug={course?.slug}
                                />
                              }
                            </TabPane>
                          </>
                        )}
                        {permission && (
                          <TabPane
                            tabId="settings"
                            key="settings"
                            className="settings-tab mb-5"
                          >
                            <RoomSettings roomData={roomData} />
                          </TabPane>
                        )}
                        {(permission ||
                          rolePermissionKey?.roommember?.view_roommember) && (
                          <TabPane tabId="members" className="members-tab mb-5">
                            <RoomMembers roomSlug={roomSlug} />
                          </TabPane>
                        )}
                      </TabContent>
                    </div>
                  </div>
                </div>
              </div>
              {isMobile || isTablet ? (
                ''
              ) : (
                <div className="col-lg-4 col-md-5 col-sm-4">
                  <div className={`col-lg-12`}>
                    <AboutCard
                      {...roomData}
                      isStaff={isStaff}
                      openSettings={() => {
                        router.push({
                          query: {
                            tab: 'settings',
                          },
                        });
                      }}
                      has_permission={permission}
                      loading={loading}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Index;
